<script setup>
import moment from "moment";
moment.locale("id");
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="w-full rounded-3xl bg-red-100 overflow-hidden shadow-md h-auto"
        >
          <div class="w-full p-3 bg-red-100">
            <span @click="$router.back()" class="cursor-pointer">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
              Detail Kontrak : <b>{{ kontrak.title }}</b>
            </span>
          </div>
          <div class="p-7 bg-white rounded-t-3xl">
            <div class="row mb-5">
              <div class="col-md-12">
                <div class="d-flex">
                  <div class="pr-2"></div>
                  <div class="row w-100">
                    <div class="col-md-10">
                      <p
                        class="mb-2"
                        style="
                          font-size: 2rem;
                          line-height: 1.5rem;
                          font-family: 'Inter-Bold';
                        "
                      >
                        {{ kontrak.title }}
                      </p>
                      <div style="font-size: 0.8rem">
                        No OA : {{ kontrak.oaNumber }}
                        <a
                          class="text-danger fs-5"
                          style="text-decoration: none"
                          >|</a
                        >
                        No PO : {{ kontrak.poNumber }}
                        <a
                          class="text-danger fs-5"
                          style="text-decoration: none"
                          >|</a
                        >
                        Status :
                        <span
                          class="text-success"
                          v-if="
                            kontrak.validityEnd >=
                            moment(dateNow).format('YYYY-MM-DD')
                          "
                          >Aktif</span
                        ><span v-else class="text-secondary">Tidak Aktif</span>
                        <a
                          class="text-danger fs-5"
                          style="text-decoration: none"
                          >|</a
                        >
                        Tingkat Resiko :
                        <span v-if="kontrak.tingkatResiko == '4'">
                          <span
                            class="badge"
                            style="background-color: #ffe5e5; color: #dd3737"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-circle"
                              style="
                                font-size: 0.5em;
                                margin-bottom: 0.25em;
                                color: #dd3737;
                              "
                            />
                            Tinggi</span
                          >
                        </span>
                        <span v-else-if="kontrak.tingkatResiko == '3'">
                          <span
                            class="badge"
                            style="background-color: #f4eadb; color: #ff8800"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-circle"
                              style="
                                font-size: 0.5em;
                                margin-bottom: 0.25em;
                                color: #ff8800;
                              "
                            />
                            Tinggi Menengah</span
                          >
                        </span>
                        <span v-else-if="kontrak.tingkatResiko == '2'">
                          <span
                            class="badge"
                            style="background-color: #ddfbec; color: #0c8953"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-circle"
                              style="
                                font-size: 0.5em;
                                margin-bottom: 0.25em;
                                color: #0c8953;
                              "
                            />
                            Rendah Menengah</span
                          >
                        </span>
                        <span v-else-if="kontrak.tingkatResiko == '1'">
                          <span
                            class="badge"
                            style="background-color: #c8bde0; color: #720c89"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-circle"
                              style="
                                font-size: 0.5em;
                                margin-bottom: 0.25em;
                                color: #720c89;
                              "
                            />
                            Rendah</span
                          >
                        </span>
                        <span v-else> - </span>
                        <!-- {{ tingkatResiko.find(tr=>tr.value==kontrak.tingkatResiko)?.label }} -->
                      </div>
                    </div>
                    <div
                      class="col-md-2"
                      v-if="userData.kontraktorID != null"
                    >
                      <button
                        type="button"
                        class="btn btn_cari w-100"
                        @click="editKontrak()"
                      >
                        Edit Kontrak
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col-md-9">
                <p
                  class="mb-1"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  INFORMASI UMUM
                </p>
                <div class="d-flex mb-3">
                  <p
                    class="me-5 fw-bolder"
                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                  >
                    {{ kontrak.namaKontraktor }}
                  </p>
                  <p
                    class="me-5"
                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                  >
                    Inisial :
                    {{ kontrak.inisial != null ? kontrak.inisial : "-" }}
                  </p>
                  <p
                    class="me-5"
                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                  >
                    Klasifikasi :
                    {{ kontrak.noIujp != null ? "Inti" : "Non Inti" }}
                  </p>
                  <p
                    class="me-5"
                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-location-dot"
                      style=""
                    />
                    {{
                      kontrak.provinsi != "Kalimantan Selatan"
                        ? "Non Lokal"
                        : "Lokal"
                    }}
                  </p>
                </div>

                <p
                  class="mb-1"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  INFORMASI KONTRAK
                </p>
                <div class="d-flex mx-2">
                  <p style="font-size: 0.9rem">
                    Nilai Kontrak : {{ nilaiKontrak }}
                  </p>
                </div>
                <div class="d-flex mx-2">
                  <p style="font-size: 0.9rem">
                    Tanggal Mulai :
                    {{ moment(kontrak.validityStart).format("YYYY-MM-DD") }}
                  </p>
                </div>
                <div class="d-flex mx-2">
                  <p style="font-size: 0.9rem">
                    Tanggal Selesai :
                    {{ moment(kontrak.validityEnd).format("YYYY-MM-DD") }}
                  </p>
                </div>
                <div class="d-flex mx-2 mb-3">
                  <p style="font-size: 0.9rem">
                    Dokumen TOR :
                    <i v-if="kontrak.torFile == null" class="text-danger"
                      >Belum ada</i
                    >
                    <a
                      v-else
                      @click="viewFile(kontrak.torFile)"
                      class="text-danger pointer"
                      ><font-awesome-icon
                        size="sm"
                        icon="fa-solid fa-file-arrow-down"
                      />
                      File Dokumen TOR</a
                    >
                  </p>
                </div>

                <!-- <hr class="hr" /> -->
                <p
                  class="mb-1"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  IZIN LEGALITAS
                </p>
                <div class="d-flex mb-3">
                  <table class="table table-borderless">
                    <tbody
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      <tr>
                        <td width="15%">No. NIB</td>
                        <td width="1%">:</td>
                        <td width="25%">{{ kontrak.noNib }}</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>No. IUJP</td>
                        <td>:</td>
                        <td>
                          {{ kontrak.noIujp != null ? kontrak.noIujp : "-" }}
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Masa Berlaku</td>
                        <td>:</td>
                        <td>
                          {{
                            kontrak.tglExpIujp != null
                              ? kontrak.tglExpIujp
                              : "-"
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-md-3">
                <div
                  class="rounded w-100 p-3"
                  style="min-height: 10vh; background-color: #fff1f1"
                >
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    INFORMASI PJO
                  </p>
                  <p
                    class="mb-1"
                    style="font-family: 'Inter-Bold'; font-size: 1.1rem"
                  >
                    {{ kontrak.namaPjo }}
                  </p>
                  <p
                    class="mb-1"
                    style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                  ></p>
                  <p
                    class="mb-1"
                    style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                  ></p>
                  <p
                    class="mb-1"
                    style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                  ></p>
                  <p
                    class="mb-1"
                    style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-user-check"
                      style="color: #df4444"
                    />
                    {{ kontrak.kompetensiPjo }}
                  </p>
                </div>
              </div>
              <div class="col-md-12">
                <p
                  class="mb-1"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  Ruang Lingkup
                </p>
                <div style="white-space: pre-line">
                  {{ kontrak.ruangLingkup }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
</template>

<script>
import GlobalDataMixin from "../../GlobalDataMixin";

import axios from "axios";
import router from "@/router";

import {
  API_BASE_URL,
  CMS_KONTRAK,
  CMS_DOWNLOAD,
  CMS_VIEW_DOCUMENT,
} from "../../constants.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const url = API_BASE_URL + CMS_KONTRAK;
const url_download = API_BASE_URL + CMS_DOWNLOAD;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;

export default {
  mixins: [GlobalDataMixin],
  name: "KontrakDetailPage",
  components: { DefaultLayout },
  data() {
    return {
      kontrak: {},
      dateNow: new Date(),
      tingkatResiko: [
        { value: 1, label: "Rendah" },
        { value: 2, label: "Rendah Menengah" },
        { value: 3, label: "Tinggi Menengah" },
        { value: 4, label: "Tinggi" },
      ],
      nilaiKontrak: "",
    };
  },
  mounted() {
    this.fetchData(this.$route.params.id);
  },
  methods: {
    fetchData(id) {
      // const user = localStorage.getItem("user_cms");
      // const tokens = JSON.parse(user);
      const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe";
      var config = {
        headers: {
          // role: role,
          // Authorization: `Bearer ${tokens.token}`,
          // Accept: "application/json",
          // "Access-Control-Allow-Origin": "*",
          // "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
          // "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
          role: role,
          Authorization: "Bearer " + this.userData.token,
          accept: "*/*",
        },
      };
      axios
        .get(url + "?id=" + id, config)
        .then((response) => {
          this.kontrak = response.data.data;
          this.nilaiKontrak = this.formatCurrency(
            response.data.data?.nilaiKontrak
          );
          // console.log(this.formatCurrency(response.data.data?.nilaiKontrak));
        })
        .catch((error) => {
          alert("Error Fetch Data Detail Kontrak : " + error.message);
          console.error("Error fetching data:", error);
        });
    },
    editKontrak() {
      router.push({
        path: "/editkontrak/" + this.$route.params.id,
        query: this.$route.query,
      });
    },
    downloadFile(filename) {
      axios
        .get(url_download + filename, { responseType: "blob" })
        .then((response) => {
          this.handleFileDownload(response.data, filename);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    handleFileDownload(blobData, filename) {
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      console.log("blob nya = ", blob);
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename; // Set the desired file name
      link.click();
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
    formatCurrency(value) {
      if (value === undefined || value === null) {
        return "Rp. 0";
      }
      if (typeof value === "string") {
        value = parseInt(value, 10);
      }

      if (!Number.isNaN(value)) {
        return "Rp. " + value.toLocaleString("id-ID");
      } else {
        return "Rp. 0";
      }
    },
  },
};
</script>
